const durationPattern = /^(\d+(?:\.\d+)?)\s*(?:min|mins|minute|minutes)?$/i;

export const normalizePlannedWorkoutMinutes = (value: unknown): string => {
  const text = String(value ?? '').trim();
  const match = text.match(durationPattern);
  return match ? String(Number(match[1])) : text;
};

export const formatPlannedWorkoutMinutes = (value: unknown): string => {
  const normalized = normalizePlannedWorkoutMinutes(value);
  const minutes = Number(normalized);
  if (!Number.isFinite(minutes) || minutes < 0 || normalized === '') {
    return normalized;
  }

  if (minutes < 60) return `${minutes} min`;

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return remainingMinutes
    ? `${hours} hr ${remainingMinutes} min`
    : `${hours} hr`;
};

export const normalizePlannedWorkoutType = (
  value: unknown,
): 'run' | 'strength' | 'recovery' | 'other' => {
  const type = String(value ?? '').toLowerCase();
  if (type.includes('run') || type.includes('race')) return 'run';
  if (type.includes('strength')) return 'strength';
  if (type.includes('recovery') || type.includes('rest')) return 'recovery';
  return 'other';
};
